import { render, staticRenderFns } from "./PremiumFeatures.vue?vue&type=template&id=5ab4aa41&scoped=true"
import script from "./PremiumFeatures.vue?vue&type=script&lang=js"
export * from "./PremiumFeatures.vue?vue&type=script&lang=js"
import style0 from "./PremiumFeatures.vue?vue&type=style&index=0&id=5ab4aa41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4aa41",
  null
  
)

export default component.exports